import { useEffect, useState } from "react";
import { resolveImage } from "@/lib/api";

export const productPhotos = (p) => [p?.image_url, ...((p && p.images) || [])].filter(Boolean);

export default function ProductGallery({ product, fallback = "", mainClass = "", contain = false }) {
  const photos = productPhotos(product);
  const [active, setActive] = useState(0);
  useEffect(() => setActive(0), [product?.product_id]);
  const current = photos[active] || photos[0];
  const fit = contain ? "object-contain bg-sand" : "object-contain bg-white";

  return (
    <div data-testid="product-gallery">
      <img
        data-testid="gallery-main-image"
        src={current ? resolveImage(current) : fallback}
        alt={product?.name || ""}
        className={`min-h-48 w-full bg-sand ${fit} ${mainClass}`}
      />
      {photos.length > 1 && (
        <div data-testid="gallery-thumbs" className="mt-3 flex flex-wrap gap-2">
          {photos.map((url, i) => (
            <button
              key={`${url}-${i}`}
              type="button"
              data-testid={`gallery-thumb-${i}`}
              onClick={() => setActive(i)}
              aria-label={`Photo ${i + 1}`}
              className={`h-16 w-16 overflow-hidden rounded-xl border-2 transition-colors ${i === active ? "border-amber-deep" : "border-transparent opacity-70 hover:opacity-100"}`}
            >
              <img src={resolveImage(url)} alt="" loading="lazy" className="h-full w-full bg-white object-contain" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
